<template>
    <h1 dir="ltr">404 Not Found Admin !</h1>
</template>

<script>
    export default {

    }
</script>